// src/api/module.ts
import apiClient from './client';

export async function fetchUserModules() {
  const res = await apiClient.get('/api/modules/user-modules');
  return res.data;
}

export async function fetchCurrentUserModule() {
  const res = await apiClient.get('/api/modules/current');
  return res.data;
}

export async function completeUserModule(userModuleId: number) {
  const res = await apiClient.post(`/api/modules/complete/${userModuleId}`);
  return res.data;
}

export async function updateModuleProgress(userModuleId: number, progressCheckpoint: number) {
  const res = await apiClient.put(`/api/modules/${userModuleId}/progress`, {
    progressCheckpoint
  });
  return res.data;
}

export async function resetUserProgress() {
  const res = await apiClient.post('/api/users/reset-progress');
  return res.data;
}

// New endpoints for structured documents
export async function fetchDocumentContent(userModuleId: number) {
  const res = await apiClient.get(`/api/modules/${userModuleId}/document-content`);
  return res.data;
}

export async function completeDocumentModule(userModuleId: number) {
  const res = await apiClient.post(`/api/modules/${userModuleId}/complete-document`);
  return res.data;
}

// New endpoints for enhanced surveys
export async function completeEnhancedSurvey(userModuleId: number) {
  const res = await apiClient.post(`/api/modules/${userModuleId}/complete-enhanced-survey`);
  return res.data;
}

export async function getEnhancedSurveyConfig(surveyId: number) {
  const res = await apiClient.get(`/api/surveys/enhanced-config/${surveyId}`);
  return res.data;
}